import React from "react";
import { Table, Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import config from "config";
const DynamicTable = ({ tableData }) => {
  const { title, header, data } = tableData;
  const backUrl = config.backOffice.url;
  // Fonction pour formater les montants
  const formatAmount = (value) => {
    if (typeof value === "number") {
      return value.toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
      });
    }
    return value;
  };

  // Fonction pour rendre le contenu d'une cellule
  const renderCellContent = (item, column) => {
    const value = item[column.accessorKey];

    if (column.formatAmount && typeof value === "number") {
      return formatAmount(value);
    }

    // Lien pour la colonne designation
    if (column.accessorKey === "designation") {
      return (
        <a
          href={`${backUrl}/projets/${item.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary text-decoration-underline"
        >
          {value || ""}
        </a>
      );
    }
    // Lien pour la colonne designation
    if (column.accessorKey === "exploitant") {
      return (
        <a
          href={`${backUrl}/partenaires_exploitants/${item.exploitant_id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary text-decoration-underline"
        >
          {value || ""}
        </a>
      );
    }

    return value || "";
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ color: "#555b21" }} className="mb-2">
          {title}
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Table responsive striped hover>
          <thead>
            <tr>
              {header.map((column, index) => (
                <th key={index} className="text-nowrap">
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, rowIndex) => (
                <tr key={item.id || rowIndex}>
                  {header.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      style={{
                        textAlign: column.formatAmount ? "right" : "",
                        fontFamily: "Arial, sans-serif",
                      }}
                    >
                      {renderCellContent(item, column)}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={header.length} className="text-center text-muted">
                  Aucune donnée disponible
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default DynamicTable;
